/**
 * One-time service-worker cleanup shim.
 *
 * The reader-web build used to ship a workbox service worker via
 * vite-plugin-pwa. We removed that plugin because it was causing stale-
 * content bugs and the PWA install affordance was broken (manifest icons
 * 404'd). Removing the plugin only stops *new* visitors from registering
 * the SW — visitors who hit the app while the plugin was active still
 * have an active SW in their browser, and that SW will keep serving the
 * old precached bundle from CacheStorage forever (workbox precache is
 * very sticky by design).
 *
 * This module unregisters any registered service worker and deletes any
 * caches it created. It's safe to call on every page load: when no SW
 * is registered (the steady state after this code has shipped for a
 * while) the calls are no-ops.
 *
 * Once telemetry shows nobody has the old SW any more, this file and
 * its main.tsx import can be deleted.
 */
export function unregisterServiceWorker(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister().catch(() => { /* best-effort */ });
    }
  }).catch(() => { /* best-effort */ });

  if (typeof caches !== 'undefined') {
    caches.keys().then((keys) => {
      for (const key of keys) {
        caches.delete(key).catch(() => { /* best-effort */ });
      }
    }).catch(() => { /* best-effort */ });
  }
}
